<div class="pdf-checkbox-preview"
     [class.clickable]="!isEditMode"
     [style.fontSize.px]="fontSize"
     [style.fontWeight]="fontWeight"
     [style.fontStyle]="fontStyle"
     [style.color]="color"
     (click)="toggleChecked()">
  <div class="checkbox-box"
       [style.width.px]="boxSize"
       [style.height.px]="boxSize"
       [style.borderColor]="boxColor"
       [style.borderWidth.px]="borderThickness"
       [style.marginRight.px]="gap">
    <span *ngIf="checked" class="check-mark"
          [style.color]="checkColor"
          [style.fontSize.px]="boxSize * 0.8">&#x2715;</span>
  </div>
  <span class="checkbox-label">{{ label }}</span>
</div>
